var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l_pagination"},[_c('el-pagination',{attrs:{"page-size":_vm.paginationParameter.pageSize,"current-page":_vm.paginationParameter.page,"layout":"total, prev, pager, next, jumper","total":_vm.paginationParameter.total},on:{"current-change":_vm.handleCurrentChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc76ea4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination/Pagination.vue
// module id = null
// module chunks = 